import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DropdownAnswerSubtypeResponse, DropdownAnswerSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/dropdownAnswerSubtype";

interface Props {
    subtype: DropdownAnswerSubtypeResponse;
    subtypeData: DropdownAnswerSubtypeDataModel;
}

export default function DropdownAnswerSubtypeSummary(props: Props) {
    const { t } = useTranslation();

    const numberPositiveAnswers = Object
        .values(props.subtypeData.answers)
        .filter(i => i === "CheckedPositive")
        .length;

    const numberItems = props.subtype.checklistItems.length;

    switch (props.subtype.checklistAnswerType) {
        case "SingleChoice":
            const positiveAnswerId = Object
                .keys(props.subtypeData.answers)
                .find(id => props.subtypeData.answers[Number(id)] === "CheckedPositive");

            const answerItem = props.subtype.checklistItems
                .find(i => i.id === Number(positiveAnswerId));

            return <Typography>{answerItem ? answerItem.text : "-"}</Typography>;

        case "MultipleChoice":
            return <Typography>{t("incentivationPage.dropdownAnswer.checkedItems", {
                checked: numberPositiveAnswers,
                total: numberItems
            })}</Typography>;

        case "MultipleChoiceWithDecline":
            return <Typography>{t("incentivationPage.dropdownAnswer.checkedItems", {
                checked: numberPositiveAnswers,
                total: numberItems
            })}</Typography>;
    }
}
